import gql from "fraql";
import { withScope, captureException } from "@sentry/vue";
import { useTranslation } from "@/plugins/i18next/i18next";
export const DisplayTextFragments = {
    translation: gql `
    fragment _ on DisplayText {
      defaultText
      params
      translationKey
      messageType
    }
  `,
    textTranslation: `
    defaultText
    params
    translationKey
    messageType
  `
};
export function useDisplayText() {
    const { t } = useTranslation();
    /**
     * Method that takes DisplayText type object and return translated text trough i18next
     * If key doesn't exist or something else threw error will report it to Sentry
     * @param props DisplayText (translationKey, defaultText, params)
     * @returns translated text
     */
    function displayText(props) {
        const { msg, key, translation_key, translationKey, defaultText, default_text, params } = props;
        let keyParam = translation_key || translationKey || key;
        let defaultParam = default_text || defaultText || translationKey || msg;
        try {
            return t([keyParam, defaultParam].filter(Boolean), params);
        }
        catch (error) {
            withScope(scope => {
                scope.setContext("display text props", {
                    props
                });
                captureException(error);
            });
            // server can return error message just as string
            if (typeof props === "string")
                return props;
            return defaultParam;
        }
    }
    /**
     * Method that handles array of DisplayText
     * @param msgs Array of DisplayText
     * @returns array of translated string texts
     */
    function translateFeedbackMessages(msgs) {
        return msgs.map(msg => displayText(msg));
    }
    function translateGraphQlErrors(graphQLErrors) {
        let errTxts = [];
        graphQLErrors.forEach(err => {
            if (err.messages && Array.isArray(err.messages)) {
                err.messages.forEach(msg => {
                    errTxts.push(displayText(msg));
                });
            }
            else if (err.message) {
                // Server may return graphql error that does not have messages, may mean the mutation/query itself is invalid
                if (typeof err.message === "object") {
                    errTxts.push(displayText(err.message));
                }
                else {
                    errTxts.push(err.message);
                }
            }
        });
        return errTxts;
    }
    return { displayText, translateFeedbackMessages, translateGraphQlErrors };
}
